import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentResolveResponse {
  id: string;
  name: string;
  avatar: string;
  intro: string;
  creator_id: string;
  workflow?: string;
  workflow_address?: string;
  subscription_time?: string;
  subscription_frequency?: string;
  type?: string;
  agent_expires_at?: number;
  created_at: Date;
  updated_at: Date;
  status?: number;
};

// 请求接口
interface ResolveRequest {
  subDomain: string;
}

// 注意：增加字段设置进数据岛，还需要在 src\utils\ssr-agent-resolve.ts 文件中 seedResolvedAgentFromSSR 函数中添加对应字段
export class AgentResolveData {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  // @Required("Avatar cannot be empty")
  @IsString("Avatar must be a string")
  avatar: string;

  @Required("status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @IsNumber("agentExpiresAt must be a number")
  agentExpiresAt?: number;
}

const transformAndValidateAgent = (
  response: AgentResolveResponse
): AgentResolveData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentResolveData);
  } catch (error) {
    console.error("Agent Resolve data validation failed:", error.message);
    throw error;
  }
};

/** 根据域名获取智能体信息（接口 success 时 data 仍可能为 null，表示未解析到智能体） */
export const agentResolve = async ({
  subDomain,
}: ResolveRequest): Promise<AgentResolveData | null> => {
  const response = await api.get<AgentResolveResponse | null>("/agent/resolve", {
    sub_domain: subDomain,
  });
  if (response.data == null) {
    return null;
  }
  return transformAndValidateAgent(response.data);
};
